/**
 * Lo que se ve cuando una pantalla tira un error al dibujarse.
 *
 * El router no tenia uno propio, y el de TanStack deja la pantalla en
 * «Something went wrong!» con el texto tecnico en ingles: abrir el cobro de un
 * cliente en dolares desde un link, antes de que llegara la cotizacion, dejaba
 * la app entera asi y la unica salida era adivinar que habia que recargar.
 */
import { AlertTriangle, RotateCw } from "lucide-react";

import { Button } from "@/components/ui/button";
import { EstadoVacio } from "@/components/ui/estado-vacio";

export function PantallaConError({ error }: { error: unknown }): JSX.Element {
  const detalle = error instanceof Error && error.message ? error.message : undefined;
  return (
    <div className="p-4 md:p-6">
      <EstadoVacio
        icono={AlertTriangle}
        titulo="Esta pantalla no se pudo mostrar"
        detalle={detalle}
        accion={
          <Button type="button" variant="outline" onClick={() => window.location.reload()}>
            <RotateCw aria-hidden="true" />
            Recargar
          </Button>
        }
      />
    </div>
  );
}
